import React from "react";
import { Pressable } from "react-native";
import Routes from "@navigations/Routes";
import CollectionView from "@components/molecules/CollectionView";
import {
  FavoritesEnum,
  collectionMenuOptions,
  shareMenuOptions,
} from "./utils/FavoritesUtils";
import { useTranslation } from "react-i18next";
import { CollectionItemProps } from "./types";
import { useTheme } from "styled-components/native";
import { useScreenWiseShareOptionConfig } from "@redux/slices/globalSlice";
import { filterDataByPriceMode } from "@utils/product/productValidators";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { navigate } from "@navigations/utils/RootNavigation";

const CollectionItem = ({
  testID,
  item,
  threeDotOptions,
  count,
  isFavorites,
  stockItemIds,
  showCheckbox,
  fromFavoriteScreen,
  checkboxFunction,
  selectCheckbox,
  selectedItem,
  setSelectedItem,
  handleReset,
}: CollectionItemProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { getPriceMode } = useUserInfo();
  const isTablet = theme.isTablet || theme.isLargeScreen;
  const getScreenWiseShareOptionConfig = useScreenWiseShareOptionConfig(
    Routes.Favorites
  );
  const handlePress = () => {
    if (setSelectedItem) {
      const navigationParams = {
        type: isFavorites
          ? FavoritesEnum.favorites_tag
          : FavoritesEnum.collection,
        collectionName: isFavorites ? "Favorites" : item?.name || "",
        collectionId: isFavorites ? 0 : item?.id || 0,
      };
      setSelectedItem(isTablet ? item?.id : 0);
      navigate(Routes.FavoritesListScreen, navigationParams);
      handleReset();
    }
  };

  const screenWiseShareOptionConfig = filterDataByPriceMode(
    Object.values(getScreenWiseShareOptionConfig || {}),
    getPriceMode()
  );
  const shareOptionConfig =
    screenWiseShareOptionConfig?.length > 0
      ? screenWiseShareOptionConfig
      : shareMenuOptions(t);
  return (
    <Pressable testID={testID} onPress={handlePress}>
      <CollectionView
        testID={testID ? `${testID}-collection-view` : undefined}
        isFavorites={isFavorites}
        collection={item}
        count={isFavorites ? count : item?.count}
        threeDotOptions={threeDotOptions}
        shareOptions={shareOptionConfig}
        menuOptions={isFavorites ? [] : collectionMenuOptions(t)}
        fromFavoriteScreen={fromFavoriteScreen}
        stock_item_ids={isFavorites ? stockItemIds : []}
        showCheckbox={showCheckbox}
        checkboxFunction={checkboxFunction}
        selectCheckbox={selectCheckbox}
        showSelected={item?.id === selectedItem}
      />
    </Pressable>
  );
};

export default CollectionItem;
